import { gql } from '@apollo/client'

export const COPY_COMMERCIAL = gql`
  mutation copyCommercial(
    $commercialId: String!
    $portfolioId: String!
  ) {
    copyCommercial(
      commercialId: $commercialId
      portfolioId: $portfolioId
    ) {
      _id
      address
      city
      state
      zip
      ownershipName
      yearBuilt
      commercialType
      sqft
      lotSize
      propertyTaxes
      assessedValue
      zoning
      createdAt
      portfolio {
        _id
        name
      }
    }
  }
`
